import { useState } from "react";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";

export function ResetPasswordModals(props: {
  onConfirmResetPassword: () => Promise<void>;
  showPasswordResetModal: boolean;
  setShowPasswordResetModal: (value: boolean) => void;
  onMount: () => void;
}) {
  const {
    onConfirmResetPassword,
    showPasswordResetModal,
    setShowPasswordResetModal,
    onMount,
  } = props;
  const [showPasswordResetSuccessModal, setShowPasswordResetSuccessModal] =
    useState<boolean>(false);
  const [showPasswordResetErrorModal, setShowPasswordResetErrorModal] =
    useState<boolean>(false);
  return (
    <>
      <ConfirmationModal
        contentText="Deseja realmente resetar a senha do usuário?"
        open={showPasswordResetModal}
        onConfirm={onConfirmResetPassword}
        setOpen={setShowPasswordResetModal}
        title="Resetar Senha"
        setOpenErrorModal={setShowPasswordResetErrorModal}
        setOpenSuccessModal={setShowPasswordResetSuccessModal}
      />
      <ActionAlert
        message="A senha do usuário foi resetada com sucesso"
        severity="success"
        open={showPasswordResetSuccessModal}
        setOpen={setShowPasswordResetSuccessModal}
        onClose={() => {
          setShowPasswordResetModal(false);
          onMount();
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao resetar a senha do usuário"
        severity="error"
        open={showPasswordResetErrorModal}
        setOpen={setShowPasswordResetErrorModal}
        onClose={() => {
          setShowPasswordResetModal(false);
        }}
      />

      {/* <ErrorModal
        contentText="Ocorreu um erro ao resetar a senha do usuário"
        open={showPasswordResetErrorModal}
        setOpen={setShowPasswordResetErrorModal}
        title="Erro ao resetar a senha"
        onClose={() => {
          setShowPasswordResetModal(false);
        }}
      />
      <SuccessModal
        contentText="A senha do usuário foi resetada com sucesso"
        open={showPasswordResetSuccessModal}
        setOpen={setShowPasswordResetSuccessModal}
        title="Senha resetada"
        onClose={() => {
          setShowPasswordResetModal(false);
          onMount();
        }}
      /> */}
    </>
  );
}
